import { ptBRCompanyDataPageTranslation } from './company-data';

export const ptBRYourDataPageTranslation = {
  your_data: {
    ...ptBRCompanyDataPageTranslation,
  },
};
